import { Dispatch } from 'redux';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { Survey } from '../../models/api';

export const updateSurveyEmail = (surveyEmail: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_SURVEY_EAMIL,
      payload: surveyEmail,
    });
  };
};

export const updateSurvey = (survey: Survey) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_SURVEY,
      payload: survey,
    });
  };
};
export const updateFetchingSurvey = (fetchingSurvey: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_FETCHING_SURVEY,
      payload: fetchingSurvey,
    });
  };
};
export const updateAnsweredSurvey = (answeredSurvey: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_ANSWERED_SURVEY,
      payload: answeredSurvey,
    });
  };
};
export const updateSurveyChoice = (surveyChoice: number) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_SURVEY_CHOICE,
      payload: surveyChoice,
    });
  };
};
export const updateSurveyFeedbackChoice = (surveyFeedbackChoice: number) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_SURVEY_FEEDBACK_CHOICE,
      payload: surveyFeedbackChoice,
    });
  };
};
